var __rspack_ns_object = {"rE":"7.8.38"}